import React from "react";
import { Modal } from "react-bootstrap";
import {
    Link, useParams, NavLink,
    Outlet,
    useLocation,
} from "react-router-dom";
// import { loginPost } from "../../redux/actions/authActions";
// import Auth from "../../auth/Auth";
import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { clearCart } from "../../helpers/help";
import moment from "moment";
import { getOutletLink1, placeholderHandler } from "../../helpers/help";


function Logout(props) {
    const { openLogoutModal, setOpenLogoutModal, data } = props;
    let { outletId } = useParams();
    outletId = +outletId;
    // const navigate = useNavigate();
    // const dispatch = useDispatch();

    return (
        <Modal
            show={openLogoutModal}
            onHide={() => setOpenLogoutModal(false)}
            centered
            className="logoutmodal center-close-icon"
        >
            <Modal.Header closeButton></Modal.Header>


            <div className="Cboady-modal">
                <div className="restaurant_modal">
                    <div className="restaurant_item">
                        <div className="restaurant_img">
                            <img
                                // src="./assets/img/Restaurantsimg.png"
                                onError={placeholderHandler}
                                src={data?.restaurantImage}
                                alt=" Restaurant img"
                                className="w-100" />
                        </div>
                        <div className="restaurant_content px-3">
                            <div className="title mb-1">
                                <h5 className="head5">
                                    {data?.restaurantName}
                                </h5>
                            </div>

                            <div className="footer_content">
                                <div className="d-block">
                                    <div className="ratingView mb-2">
                                        <img src="./assets/img/ratingStart.svg" alt="rating view" className="me-1" />
                                        {data?.averageReview}
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="mintB me-3">{data?.displayTime}</div>
                                        {data?.outlet?.length && data.outlet[0] && (
                                            <span className="timeshow">
                                                {moment(data.outlet[0].business_hours.from_time, "h:mm a").format("h:mm A")} -{" "}
                                                {moment(data.outlet[0].business_hours.to_time, "h:mm a").format("h:mm A")}
                                            </span>
                                        )} <span
                                            className="ratingView d-flex align-items-center">

                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="centerBr"></div>
                    <div className="head4 mb-2"><span>{data?.outlet?.length} Outlets </span> Near You</div>
                    {
                        data && data?.outlet.map((outletName) => {
                            return (
                                < Link to={getOutletLink1(outletName?.outletId)} className="white_modalBox p-3">
                                    <div className="restaurant_item justify-content-between">

                                        <div className="restaurant_content">
                                            <div className="title mb-1">
                                                <a routerLink="/restaurant-detail" className="head6">
                                                    {outletName?.outletName}
                                                </a>
                                            </div>

                                            <div className="footer_content">
                                                <div className="d-block">

                                                    <div className="d-flex align-items-center">
                                                        <div className="mintB me-3">{outletName?.displayTime}</div>
                                                        <span
                                                            className="timeshow"
                                                        >
                                                            {/* {moment(outletName?.business_hours.from_time, " H:mm").format(" H:mm")} AM -
                                                            {moment(outletName?.business_hours.to_time, " H:mm").format(" H:mm")} PM */}
                                                            {moment(outletName?.business_hours.from_time, " h:mm a").format(" h:mm A")} -
                                                            {moment(outletName?.business_hours.to_time, " h:mm a").format(" h:mm A")}
                                                        </span>
                                                        <span
                                                            className="ratingView d-flex align-items-center">

                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="restaurant_col-r">

                                            <div className="d-flex align-items-center">

                                                <img src="./assets/img/ratingStart.svg" alt="rating view" className="me-1" />
                                                {outletName?.averageReview}
                                            </div>
                                            {/* {outletName?.emergency_close === 0 ? (
                                                <div className="btn_res open">Open</div>
                                            ) : (
                                                <div className="btn_res close">Close</div>
                                            )} */}
                                            {/* {
                                                outletName?.emergency_close === 0 ? (
                                                    <img
                                                        src="./assets/img/deliveryModal.png"
                                                        alt="deliveryModal"
                                                        className="deliveryModal-img"
                                                    />
                                                ) : "N/A"
                                            } */}

                                        </div>
                                    </div>
                                </Link>
                            )
                        })
                    }


                    {/* <div className="white_modalBox p-3 mt-3">
                        <div className="restaurant_item justify-content-between">

                            <div className="restaurant_content">
                                <div className="title mb-1">
                                    <a routerLink="/restaurant-detail">
                                        Roosters Salad Bar
                                    </a>
                                </div>

                                <div className="footer_content">
                                    <div className="d-block">

                                        <div className="d-flex align-items-center">
                                            <div className="mintB me-3">10
                                                mins</div>
                                            <span className="timeshow">12:00 AM - 11:59 PM</span> <span
                                                className="ratingView d-flex align-items-center">

                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="restaurant_col-r">
                                <div className="ratingView mb-2">
                                    <img src="./assets/img/ratingStart.svg" alt="rating view" className="me-1" />
                                    4.5
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>

            </div>
        </Modal>
    );
}

export default Logout;